const mapPaginationListFromApi = <Item, ApiItem>(
  resp: ApiPaginationListResponse<ApiItem>,
  itemProvider: (apiItem: ApiItem) => Item
): PaginationList<Item> => {
  return {
    pageCount: resp.pages.page_count,
    currentPage: resp.pages.page_current + 1,
    items: resp.items.map((item) => itemProvider(item)),
    itemsCount: resp.items_total,
  };
};

export default mapPaginationListFromApi;
